export const alcaldeRole = {
  path: '/alcalde',
  redirect: 'noredirect',
  name: 'alcalde',
  single: false,
  meta: {
    title: 'ALCALDE',
    icon: 'audit',
    roles: ['super', 'admin', 'auditoria']
  }
}
export default alcaldeRole
